import { Box, Heading } from '@chakra-ui/react'
import React from 'react'

export const Navbar = () => {
  return (
    <Box pt={3}>
        <Heading >Content Generator App</Heading>
    </Box>
  )
}
